export const PMTemplatePerformancePoint = {
    getDataForInteior(){
        console.log("here")
        return [
            {
                performanceBonusMeasReview: "Number of active projects",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Number of FS projects",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Weekly workload rating 1-10",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Weekly active client update <Friday 6pm - 5 points	",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Weekly FSP client update <Friday 6pm - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Respond to active clients within 24 hours",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Time clock filled out correctly with notes <10am next day - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Direct reports time approved <6pm next day - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Direct report Playbook Meeting weekly complete <4pm Tuesday - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Scorecard complete <4:30pm Monday - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Review all selections/to do's to ensure they are up to date - 5 points	",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Review all active bids status, respond to RFI's - 5 points	",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Check that PO's are 'Saved & Released' - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "EP - Demonstrate Core Values, Core Values Shout Out - 1 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "EP - Demonstrate Core Values above and beyond - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "CE - Old specs and drawings left in the specs and selections area and not removed with the new specs and drawings added. - minus 5 points	",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "CE - On project. Defined as losing the company more than $100.00 in time or material - minus 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "CE - Defined as costing the company to lose more than $500.00 in time or material 20 points for each instance - minus 20 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "CE - Design plans not correct or measurements incorrect. - minus 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            
        ];
    },
    getDataForVp(){
        console.log("here")
        return [
            {
                performanceBonusMeasReview: "Number of Active jobs",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Number of PSA jobs",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Weekly workload rating 1-10",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Time clock filled out correctly everyday <9am the next day with notes - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Direct reports time clock viewed and approved <6pm next day - 5 points ",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Direct reports scorecard filled out <6pm Monday - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Playbook complete <6pm Friday - 5 points ",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Complete all active site inspections by 15/30th - 5 points	",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Complete all active project reviews and send email to all PM's - 5 points	",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Review Billable VS Unbillable time the first week of every PP - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Huddle Meeting with all PM's/ID Manager/Pre Con Manager every 2 weeks - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Buildertrend Actuals entered into LIDA Homes Production Schedule (Projects and Cashflow) >7th - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "P&L Standard (Budget Actuals) uploaded into LIDA Group of Companies Cashflow and reviewed >25th - 5 points	",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "P&L by Job uploaded into the LIDA Group of Companies Cashflow and reviewed >25th - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Production schedule checked and adjusted >15th - 5 points ",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Receivables - No overdue invoices >7 days w/o speaking to PM, 14 days speak with President - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Complete all client check ins for active jobs >30th - 5 points ",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "EP:  Demonstrate Core Values above and beyoned - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "EP:  Demonstrate Core Values Core Value shout out - 1 point",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "CE:  Loosing the company >$100 time/materials - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "CE:  Loosing the company >500 time/materials - 20 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            
        ];
    },
    getDataForAll(){
        console.log("here")
        return [
            {
                performanceBonusMeasReview: "Number of Active jobs",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Number of FSA jobs",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Weekly workload rating 1-10",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Time clock filled out correctly everyday <9am the next day with notes - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Direct reports time clock viewed and approved <6pm next day - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Direct reports scorecard filled out <6pm Monday - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Playbook complete <6pm Friday - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "PM Weekly Client Status Update <6pm Friday -10 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Projects are all on schedule/adjusted <6pm Friday - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Completion date in Production Schedule correct - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Daily logs completed 1 per job every day - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Trade partners advised 2M, 1M, 1W, 3D, 1D before scheduled/material needed on site - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "2 relevent pictures per week/job and 1 for social media - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Weekly tool box meeting BT TODO complete 1 per job/week - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Site clean and organized - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Daily/Weekly Foreman production goal written in BT - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Budgets - any lines over $500.00 >17th/2nd every project 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "LIDA BT labour budget consistent with % of competion - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "PM BT Contractor & Material TODO's upto date - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "PM BT QC TODO's upto date - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "PO/Sub-Agreements are upto date - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "All invoices cost coded by Friday < 6 pm  - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Invoices - sent out prior to the 15th/30th/budget on/client notified- 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Receivables - any invoices over 7 days w/o VP aware, 14 days O/D - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "PM Daily Plan upto date - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "ED:Dispatches Mon-Fri <6pm - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "ED:Manpower update for next week documnted in BT <6pm - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "EP:  Demonstrate Core Values above and beyoned - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "EP:Demonstrate Core Values Core Value shout out - 1 point",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "CE:Loosing the company >$100 time/materials - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "CE:Loosing the company >500 time/materials - 20 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "CE:Not comparing invoice to budget and/or ensuring the invoice is correct amount on the LIDA Homes invoice.",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            }
        ];
    },
    getDataForInteiorgoalForTheWeek(){
        return [
            {
                title: '',
                status: 'Y',
                description: 'Last weeks Goals: ',
            }, 
            {
                title: ' Cavendish',
                status: 'Y',
                description: 'his Weeks Goals: Check in with door supplier, working on quotes this week; review teh current drawings for tile benches to be added; check in with client for tile, counter selection so far',
            },
            {
                title: ' Sunset Cabana ',
                status: 'Y',
                description: 'Last Weeks Goals:Check in with Slegg for response to door order; order pulls; PO for shower glass; help coordinate sail shade for pool deck',
            },
            {
                title: 'Ashdowne - ID job only (no construction, so no schedule syncing required)',
                status: 'Y',
                description: 'Last Weeks Goals: Set schedule templates for the job; continue with drawings ',
            }, 
            {
                title: 'Greenlea',
                status: 'Y',
                description: 'Last Weeks Goals: Finalise the tile, flooring, grout, paint selections; updated drawings, schedule once completed to Creative; review the lighting and the hood fan issues with Nick when he gets to the site ',
            }, 
            {
                title: 'Bamford',
                status: 'Y',
                description: 'Last Weeks Goals: Contact clients for chat around starting interior design, window details',
            }, 
            {
                title: 'FSA - Sea View',
                status: 'Y',
                description: 'Last Weeks Goals:  review and send feedback on plans',
            }, 
            {
                title: '',
                status: 'Y',
                description: 'Last Weeks Goals: permit in- Mika to work with client for interior design; meet with her for hand-offf of ID so far and plan changes					',
            }, 
            {
                title: 'FSA - Glenwood',
                status: 'Y',
                description: 'Last weeks Goals: contact client to ask re: structural engineer engagement',
            }, 
            {
                title: 'FSA - Downey',
                status: 'Y',
                description: 'Last Weeks Goals: Send plans for truss layout; contribute to the meeting re: budget; touch base with engineers for timeline; send update',
            }, 
            {
                title: 'FSA - Epworth',
                status: 'Y',
                description: 'Last Weeks Goals: Talk to clients; deal with issue around us not knowing about the Oak Bay garden suites ',
            }, 
            {
                title: '',
                status: 'Y',
                description: 'Last weeks Goals: ',
            }, 
            {
                title: 'INTERNAL/OFFICE/SALES',
                status: 'Y',
                description: 'Last Weeks Goals: Lafayette photos April 15 - done',
            }, 
        ];
    },
    
    getFormName() {
       var roleID = localStorage.getItem('role_id');

        return {

            q1:'',
            q2:'',
            q3:'',
            q4:'',

            vpCommentsq1: "",
            vpCommentsq2: "",
            vpCommentsq3: "",
            vpCommentsq4: "",
            vpCommentsq5: "",

            coreValuesq1:'',
            coreValuesq2:'',
            coreValuesq3:'',
            coreValuesq4:'',

            
            projectPerfomanceID: 0,
            user_id: "",
            role_id: "",
            date: "",
            from_date:'',
            checkInHowAreYouDoing:'',
            whatCanIdoTosupporty:'',

            vpComOpsq1:'',
            vpComOpsq2:'',
            vpComOpsq3:'',
            vpComOpsq4:'',
           

            performance:roleID==18?this.getDataForInteior():roleID==12?this.getDataForVp(): this.getDataForAll(),
            discussionItem: [
                { 
                discussion_items:''}
             ],
            goalForTheWeek:roleID==18?this.getDataForInteiorgoalForTheWeek():[
                {
                    title: '',
                    status: 'Y',
                    status_2: 'Y',
                    description: '',
                    description_2: '',
                }


            ],
            toDiscuss: [
               { title:'',
                description:''}
            ]

        }
    },
  
    getPBMREVIEW(index) {
        var val = ['Number of Active jobs', 'Number of PSA jobs', 'Weekly workload rating 1-10', 'Time clock filled out correctly everyday <9am the next day with notes - 5 points', 'Direct reports time clock viewed and approved <6pm next day - 5 points 	', 'Direct reports scorecard filled out <6pm Monday - 5 points', 'Playbook complete <6pm Friday - 5 points', 'PM Weekly Client Status Update <6pm Friday -10 points', 'Projects are all on schedule/adjusted <6pm Friday - 5 points', 'Completion date in Production Schedule correct - 5 points', 'Daily logs completed 1 per job every day - 5 points', 'Trade partners advised 2M, 1M, 1W, 3D, 1D before scheduled/material needed on site - 5 points', '2 relevent pictures per week/job and 1 for social media - 5 points	', 'Weekly tool box meeting BT TODO complete 1 per job/week - 5 points', 'Site clean and organized - 5 points', 'Daily/Weekly Foreman production goal written in BT - 5 points', 'Budgets - any lines over $500.00 >17th/2nd every project 5 points', 'LIDA BT labour budget consistent with % of competion - 5 points', 'PM BT Contractor & Material TODO\'s upto date - 5 points', 'PM BT QC TODO\'s upto date - 5 points', 'PO/Sub-Agreements are upto date - 5 points', 'All invoices cost coded by Friday < 6 pm  - 5 points', 'Invoices - sent out prior to the 15th/30th/budget on/client notified- 5 points	', 'Receivables - any invoices over 7 days w/o VP aware, 14 days O/D - 5 points', 'PM Daily Plan upto date - 5 points		', 'ED:  Dispatches Mon-Fri <6pm - 5 points', 'ED:  Manpower update for next week documnted in BT <6pm - 5 points	', 'EP:  Demonstrate Core Values above and beyoned - 5 points	', 'EP:  Demonstrate Core Values Core Value shout out - 1 point', 'CE:  Loosing the company >$100 time/materials - 5 points	', 'CE:  Loosing the company >500 time/materials - 20 points', 'CE: Not comparing invoice to budget and/or ensuring the invoice is correct amount on the LIDA Homes invoice.',];
        return val[index];
    }, 
    performanceAdd(){

      return  {
            performanceBonusMeasReview: "Number of active projects",
            clientPlayBook: "",
            vpPoints_1: "",
            clientEmailWeek: "",
            vpPoints_2: "",
            pmComments: "",
            vpCOComments: ""
        };
    }

    

}